export default async function getEcoTaxi({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'ecoTaxi');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
